import React from "react";
import { fallbackValues } from "./Icons.theme";
import { themeComponent } from "../../../util/themeUtils";

// When ariaHidden is true, aria-hidden="true" is added to the SVG, which tells
// screen readers to skip this element. Use this when the icon is purely decorative
// and adjacent text already conveys its meaning (e.g. an icon inside a labeled nav link).
const SettingsIconSmall = ({ themeValues, ariaHidden = true }) => {
  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 2 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ display: "inline-block", verticalAlign: "text-bottom" }}
      aria-hidden={ariaHidden ? "true" : undefined}
    >
      <defs>
        <rect
          id="path-1-paymentssmall"
          x="0"
          y="0"
          width="29"
          height="27"
        ></rect>
      </defs>
      <g
        id="Random-Icon-Work"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Header/Desktop/Menu">
          <g id="Header/Desktop/Menu/Settings-Tab">
            <g>
              <g id="Payments">
                <g id="cog">
                  <mask id="mask-2-paymentssmall" fill="white">
                    <use xlinkHref="#path-1-paymentssmall"></use>
                  </mask>
                  <g id="Mask"></g>
                  <path
                    d="M13.9335677,21.7578083 C14.0273176,21.7343707 14.103489,21.6816364 14.1620828,21.5996056 C14.2206766,21.5175747 14.2499732,21.4296843 14.2499732,21.3359343 L14.2499732,19.6132822 C15.0468465,19.3320328 15.7616883,18.9218774 16.3944993,18.3828164 L17.8710583,19.2617205 C17.9648082,19.3085952 18.0585577,19.3203143 18.1523076,19.2968767 C18.2460576,19.2734391 18.3280885,19.2265643 18.3984008,19.156252 C19.2890235,18.195317 19.9335536,17.0937568 20.3319899,15.8515724 C20.3554276,15.7578224 20.349568,15.664073 20.3144118,15.5703231 C20.2792557,15.4765731 20.2148029,15.4062608 20.1210529,15.3593861 L18.644494,14.4804819 C18.7851186,13.6601715 18.7851186,12.8398606 18.644494,12.0195503 L20.1210529,11.1406461 C20.2148029,11.0937714 20.2792557,11.0234591 20.3144118,10.9297091 C20.349568,10.8359592 20.3554276,10.7422098 20.3319899,10.6484598 C19.9335536,9.40627544 19.2890235,8.3047152 18.3984008,7.34378017 C18.3280885,7.27346784 18.2460576,7.22659313 18.1523076,7.20315551 C18.0585577,7.17971789 17.9648082,7.19143697 17.8710583,7.23831168 L16.3944993,8.11721583 C15.7616883,7.57815479 15.0468465,7.16799934 14.2499732,6.88675001 L14.2499732,5.16409787 C14.2499732,5.07034792 14.2206766,4.9824575 14.1620828,4.90042663 C14.103489,4.81839575 14.0273176,4.7656615 13.9335677,4.74222388 C12.6445081,4.46097455 11.355449,4.46097455 10.0663894,4.74222388 C9.97263945,4.7656615 9.89646811,4.81839575 9.83787432,4.90042663 C9.77928053,4.9824575 9.74998391,5.07034792 9.74998391,5.16409787 L9.74998391,6.88675001 C8.95311063,7.16799934 8.23826876,7.57815479 7.60545777,8.11721583 L6.12889879,7.23831168 C6.03514883,7.19143697 5.94139942,7.17971789 5.84764946,7.20315551 C5.75389951,7.22659313 5.67186863,7.27346784 5.6015563,7.34378017 C4.7109336,8.3047152 4.06640353,9.40627544 3.66796716,10.6484598 C3.64452953,10.7422098 3.65038907,10.8359592 3.68554524,10.9297091 C3.72070141,11.0234591 3.7851542,11.0937714 3.87890415,11.1406461 L5.35546313,12.0195503 C5.21483847,12.8398606 5.21483847,13.6601715 5.35546313,14.4804819 L3.87890415,15.3593861 C3.7851542,15.4062608 3.72070141,15.4765731 3.68554524,15.5703231 C3.65038907,15.664073 3.64452953,15.7578224 3.66796716,15.8515724 C4.06640353,17.0937568 4.7109336,18.195317 5.6015563,19.156252 C5.67186863,19.2265643 5.75389951,19.2734391 5.84764946,19.2968767 C5.94139942,19.3203143 6.03514883,19.3085952 6.12889879,19.2617205 L7.60545777,18.3828164 C8.23826876,18.9218774 8.95311063,19.3320328 9.74998391,19.6132822 L9.74998391,21.3359343 C9.74998391,21.4296843 9.77928053,21.5175747 9.83787432,21.5996056 C9.89646811,21.6816364 9.97263945,21.7343707 10.0663894,21.7578083 C11.355449,22.0390576 12.6445081,22.0390576 13.9335677,21.7578083 Z M11.9999785,16.0625094 C11.2265429,16.0625094 10.5644353,15.7871196 10.0136552,15.2363395 C9.46287504,14.6855594 9.18748525,14.0234517 9.18748525,13.2500161 C9.18748525,12.4765804 9.46287504,11.8144728 10.0136552,11.2636927 C10.5644353,10.7129126 11.2265429,10.4375228 11.9999785,10.4375228 C12.7734142,10.4375228 13.4355218,10.7129126 13.9863019,11.2636927 C14.537082,11.8144728 14.8124718,12.4765804 14.8124718,13.2500161 C14.8124718,14.0234517 14.537082,14.6855594 13.9863019,15.2363395 C13.4355218,15.7871196 12.7734142,16.0625094 11.9999785,16.0625094 Z"
                    id="c"
                    fill={themeValues.singleIconColor}
                    fillRule="nonzero"
                    mask="url(#mask-2-paymentssmall)"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default themeComponent(
  SettingsIconSmall,
  "Icons",
  fallbackValues,
  "primary"
);
